// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountValidatorController from "./account_validator_controller"
application.register("account-validator", AccountValidatorController)

import AddressLookupController from "./address_lookup_controller"
application.register("address-lookup", AddressLookupController)

import AdventurePreviewController from "./adventure_preview_controller"
application.register("adventure-preview", AdventurePreviewController)

import AdventuresMapController from "./adventures_map_controller"
application.register("adventures-map", AdventuresMapController)

import CommandFormController from "./command_form_controller"
application.register("command-form", CommandFormController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DebouncedValidateController from "./debounced_validate_controller"
application.register("debounced-validate", DebouncedValidateController)

import DiscountCodeController from "./discount_code_controller"
application.register("discount-code", DiscountCodeController)

import EmailFormController from "./email_form_controller"
application.register("email-form", EmailFormController)

import EmailsFormController from "./emails_form_controller"
application.register("emails-form", EmailsFormController)

import FencesController from "./fences_controller"
application.register("fences", FencesController)

import FencesCopyController from "./fences_copy_controller"
application.register("fences-copy", FencesCopyController)

import FencesFormController from "./fences_form_controller"
application.register("fences-form", FencesFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import IgpsController from "./igps_controller"
application.register("igps", IgpsController)

import ImageCarouselController from "./image_carousel_controller"
application.register("image-carousel", ImageCarouselController)

import ImageFieldController from "./image_field_controller"
application.register("image-field", ImageFieldController)

import InlineFormController from "./inline_form_controller"
application.register("inline-form", InlineFormController)

import LimitedTextFieldController from "./limited_text_field_controller"
application.register("limited-text-field", LimitedTextFieldController)

import LocalTimeController from "./local_time_controller"
application.register("local-time", LocalTimeController)

import MapController from "./map_controller"
application.register("map", MapController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import RemotePaginationController from "./remote_pagination_controller"
application.register("remote-pagination", RemotePaginationController)

import RepairmodalController from "./repairmodal_controller"
application.register("repairmodal", RepairmodalController)

import ResourceModalController from "./resource_modal_controller"
application.register("resource-modal", ResourceModalController)

import RichTextController from "./rich_text_controller"
application.register("rich-text", RichTextController)

import ServiceOrderCartController from "./service_order_cart_controller"
application.register("service-order-cart", ServiceOrderCartController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StarController from "./star_controller"
application.register("star", StarController)

import SummernoteMediaUploadController from "./summernote_media_upload_controller"
application.register("summernote-media-upload", SummernoteMediaUploadController)

import TaggableController from "./taggable_controller"
application.register("taggable", TaggableController)

import TicketPreviewController from "./ticket_preview_controller"
application.register("ticket-preview", TicketPreviewController)

import TranslateController from "./translate_controller"
application.register("translate", TranslateController)

import UpdateCheckController from "./update_check_controller"
application.register("update-check", UpdateCheckController)

import XlsxFormController from "./xlsx_form_controller"
application.register("xlsx-form", XlsxFormController)
